"use client";

import {
  TypeCtaSkeleton,
  TypePackageDetailWithCarousalSkeleton,
} from "@contentful/types";
import { Button } from "@yardzen/ui/components/button";
import { Icon } from "@yardzen/ui/components/icon";
import { Link } from "@yardzen/ui/components/link";
import { Entry } from "contentful";
import { useBuilderPartnerCheckoutHref } from "./builderPartnerCheckoutHref";
import { ImageCollection } from "./ImageCollection";
import { PackageDetailItem } from "./PackageDetailItem";

export function PackagePreviewModal({
  packageInfo,
  cta,
  checkoutV2,
}: {
  packageInfo?: Entry<
    TypePackageDetailWithCarousalSkeleton,
    "WITHOUT_UNRESOLVABLE_LINKS"
  >;
  cta?: Entry<TypeCtaSkeleton, "WITHOUT_UNRESOLVABLE_LINKS">;
  checkoutV2?: boolean;
}) {
  const { package: packageDetailItem, carousal: imageCollection } =
    packageInfo?.fields || {};
  const withBuilderPartnerParams = useBuilderPartnerCheckoutHref();

  return (
    <div className="flex flex-col md:flex-row">
      <div className="min-w-md mx-auto max-w-lg basis-1/2 items-center justify-center">
        {imageCollection && (
          <ImageCollection
            imageCollection={imageCollection}
            variant={"modal"}
          />
        )}
      </div>

      <div className="min-w-md max-w-m flex max-h-[40vh] flex-shrink-0 basis-1/2 flex-col px-2 sm:max-h-[554px] sm:px-4">
        {packageDetailItem && (
          <div className="flex-1 overflow-y-auto">
            <PackageDetailItem
              packageDetailItem={packageDetailItem}
              variant={"modal"}
            />
          </div>
        )}
        {cta && (
          <div className="mt-4 flex-shrink-0 items-center justify-center sm:justify-start">
            <Button asChild className="w-full sm:w-auto">
              <Link
                href={withBuilderPartnerParams(
                  checkoutV2 ? cta.fields.challengerURL : cta.fields.url,
                )}
              >
                {cta.fields.buttonText}
                <Icon name="arrow-right" />
              </Link>
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
